<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Werkelijke belichting</strong>
                        <small>
                            <span v-show="werkelijkbestaat">wijzigen</span>
                            <span v-show="!werkelijkbestaat">creëren</span>
                        </small>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm">
                                <tbody>
                                <tr>
                                    <th>Afdeling: </th><td>{{model.afdeling.naam}}</td>

                                </tr>
                                <tr>
                                    <th>Gewas: </th><td>{{model.teelt.naam}} - {{model.ras}}</td>
                                    <th>Aanplantdatum - einddatum: </th>
                                    <td>{{datumDDMMYYYY(model.aanplantdatum)}} - {{datumDDMMYYYY(model.einddatum)}}</td>
                                </tr>
                                <tr>
                                    <th>Gewenste DLI: </th><td>{{model.ingesteldeDli}}</td>
                                    <th>Belichtingsseizoen start - einde: </th>
                                    <td>{{datumDDMMYYYY(model.startdatumBelichting)}} - {{datumDDMMYYYY(model.einddatumBelichting)}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            &nbsp;<br />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>Installatie (&#181;mol/m<sup>2</sup>s)</th>
                                    <th>Efficiëntie (&#181;mol/J)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(belichting, indexi, i) in model.afdeling.belichting_n">
                                    <template v-for="(schakelniveau, indexj, i) in belichting.schakelniveau_n">
                                        <tr>
                                            <td>Systeem {{schakelniveau.nummer + 1}}</td>
                                            <td>{{belichting.soortbelichting.naam}} {{indexj + 1}}</td>
                                            <td>{{komma4(installatie[schakelniveau.nummer])}}</td>
                                            <td>{{belichting.efficientie}}</td>
                                        </tr>
                                    </template>
                                </template>

                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            &nbsp;<br />
                        </div>
                    </div>

                    <div v-if="urenbestaat || werkelijkbestaat">

                        <div v-show="!werkelijkbestaat" class="row">
                            <div class="col-12">
                                <p class="red">Er bestaat voor deze teelt nog geen formulier om de werkelijke belichtingsuren in te vullen.</p>
                            </div>
                            <div class="col-12">
                                &nbsp;<br />
                            </div>
                        </div>

                        <div v-show="werkelijkbestaat" class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <b-button-group id="periode" name="periode">
                                        <b-button @click="changeView('data')" variant="outline-secondary" :pressed="currentview == 'data'">DLI</b-button>
                                        <b-button @click="changeView('grafiek')" variant="outline-secondary" :pressed="currentview == 'grafiek'">Energie</b-button>
                                    </b-button-group>
                                </div>
                                &nbsp<br />
                            </div><!--/.col-->
                            <div v-show="currentview == 'grafiek'" class="col-sm-6">

                            </div><!--/.col-->
                        </div>

                        <!-- DLI -->
                        <div v-if="werkelijkbestaat && currentview == 'data'" class="row animated fadeIn">
                            <div class="col-12">
                                <table class="table table-striped table-sm text-center table-fixed">
                                    <thead>
                                    <tr>
                                        <th class="rborder"></th>
                                        <th class="rborder" colspan="2"></th>
                                        <th style="text-align: center;" :colspan="aantalsystemen" v-if="ideaalzichtbaar">Ideaal</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="toggleideaalzichtbaar()" title="toon/verberg">
                                                <i :class="[ideaalzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 1)" v-if="voorstelzichtbaar">Voorstel</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="togglevoorstelzichtbaar()" title="toon/verberg">
                                                <i :class="[voorstelzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 1)" v-if="werkelijkzichtbaar">Werkelijk</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="togglewerkelijkzichtbaar()" title="toon/verberg">
                                                <i :class="[werkelijkzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="aantalsystemen" v-if="urenzichtbaar">Klassiek</th>
                                        <th>
                                            <a href="javascript:void(0)" @click="toggleurenzichtbaar()" title="toon/verberg">
                                                <i :class="[urenzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                    </tr>
                                    <tr>
                                        <th class="rborder"></th>
                                        <th>DLI gewenst</th>
                                        <th class="rborder">DLI zon</th>
                                        <template v-if="ideaalzichtbaar">
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="aantalsystemen" class="rborder">Belichtingsuren</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar">
                                            <th></th>
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="aantalsystemen" class="rborder">Belichtingsuren</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <th></th>
                                            <th style="text-align: center;">DLI belichting</th>
                                            <th style="text-align: center;" :colspan="aantalsystemen" class="rborder">Belichtingsuren</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar">
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen)">Belichtingsuren</th>
                                        </template>
                                        <template v-else><th></th></template>
                                    </tr>
                                    <tr>
                                        <th class="rborder">Datum</th>
                                        <th>(mol/m<sup>2</sup>)</th>
                                        <th class="rborder">(mol/m<sup>2</sup>)</th>
                                        <template v-if="ideaalzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                               <th style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == i) }">{{i}}</th>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar">
                                            <th></th>
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == i) }">{{i}}</th>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <th></th>
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == i) }">{{i}}</th>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                        </template>
                                        <template v-else><th></th></template>

                                    </tr>

                                    <!-- truukje om kolommen overeen te laten komen -->
                                    <tr style="visibility: collapse">
                                        <td class="rborder">23/02/2020</td>
                                        <td>22.0</td>
                                        <td class="rborder">22.0</td>

                                        <template v-if="ideaalzichtbaar">
                                            <td>22.0</td>
                                            <template v-for="(systeem, indexk) in modellichtintegratie.klassiekebelichting_n[0].systemen">
                                                <td style="text-align: center;">
                                                    00:00
                                                </td>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar && voorstelbestaat">
                                            <td v-if="voorstelbestaat">
                                                <a href="javascript:void(0)">
                                                    <i class="fa fa-refresh licht"></i>
                                                </a>
                                            </td>
                                            <td v-if="voorstelbestaat">22.00</td>
                                            <template v-if="voorstelbestaat">
                                                <template v-for="(systeem, indexk) in modelvoorstel.werkelijkebelichting_n[0].systemen">
                                                    <td style="text-align: center;">
                                                        00:01
                                                    </td>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <td>
                                                <a href="javascript:void(0)">
                                                    <i class="fa fa-navicon"></i>
                                                </a>
                                            </td>
                                            <td style="text-align: center;">22.00</td>
                                            <template v-for="(perdag, indexj) in model.werkelijkebelichting_n[0].werkelijkperdag_n">
                                                <td style="text-align: center;"><!-- {{perdag.tijd}} -->
                                                    <!-- zeker niet meer dan 50 schakelniveaus per afdeling -->
                                                    <div class="centered">
                                                        <input type="text" v-mask="'##:##'" class="form-control unstyleduur" />
                                                    </div>
                                                </td>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar && urenbestaat">
                                            <td>1.00</td>
                                            <template v-for="(klassiekperdag, indexk) in modelklassiekeuren.klassiekebelichting_n[0].klassiekperdag_n">
                                                <td style="text-align: center;">00:02</td>
                                            </template>
                                        </template>
                                        <template v-else><th></th></template>

                                    </tr>
                                    <!-- tot hier -->

                                    </thead>

                                    <tbody>

                                    <!-- truukje om kolommen overeen te laten komen -->
                                    <tr style="visibility: collapse">
                                        <th class="rborder"></th>
                                        <th class="rborder" colspan="2"></th>
                                        <th style="text-align: center;" :colspan="aantalsystemen" v-if="ideaalzichtbaar">Ideaal</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="toggleideaalzichtbaar()" title="toon/verberg">
                                                <i :class="[ideaalzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 1)" v-if="voorstelzichtbaar">Voorstel</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="togglevoorstelzichtbaar()" title="toon/verberg">
                                                <i :class="[voorstelzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 1)" v-if="werkelijkzichtbaar">Werkelijk</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="togglewerkelijkzichtbaar()" title="toon/verberg">
                                                <i :class="[werkelijkzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="aantalsystemen" v-if="urenzichtbaar">Klassiek</th>
                                        <th>
                                            <a href="javascript:void(0)" @click="toggleurenzichtbaar()" title="toon/verberg">
                                                <i :class="[urenzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                    </tr>
                                    <tr style="visibility: collapse">
                                        <th class="rborder"></th>
                                        <th>DLI gewenst</th>
                                        <th class="rborder">DLI zon</th>
                                        <template v-if="ideaalzichtbaar">
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="aantalsystemen" class="rborder">Belichtingsuren</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar">
                                            <th></th>
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="aantalsystemen" class="rborder">Belichtingsuren</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <th></th>
                                            <th style="text-align: center;">DLI belichting</th>
                                            <th style="text-align: center;" :colspan="aantalsystemen" class="rborder">Belichtingsuren</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar">
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen)">Belichtingsuren</th>
                                        </template>
                                        <template v-else><th></th></template>
                                    </tr>
                                    <tr style="visibility: collapse">
                                        <th class="rborder">Datum</th>
                                        <th>(mol/m<sup>2</sup>)</th>
                                        <th class="rborder">(mol/m<sup>2</sup>)</th>
                                        <template v-if="ideaalzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == i) }">{{i}}</th>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar">
                                            <th></th>
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == i) }">{{i}}</th>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <th></th>
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == i) }">{{i}}</th>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                        </template>
                                        <template v-else><th></th></template>

                                    </tr>
                                    <!-- tot hier -->


                                    <tr v-for="(werkelijk, indexi) in model.werkelijkebelichting_n">
                                        <td class="rborder">{{datumDDMMYYYY(werkelijk.datum)}}</td>
                                        <td>{{werkelijk.gewensteDli}}</td>
                                        <td class="rborder">{{werkelijk.dliZon}}</td>
                                        <template v-if="ideaalzichtbaar">
                                            <td>{{komma2(modellichtintegratie.klassiekebelichting_n[indexi].dliBelichting)}}</td>
                                            <template v-for="(systeem, indexk) in modellichtintegratie.klassiekebelichting_n[indexi].systemen">
                                                <td style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == (indexk + 1)) }">
                                                    {{systeem.belichtingsuren}}
                                                </td>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar && voorstelbestaat">
                                            <td v-if="voorstelbestaat">
                                                <a href="javascript:void(0)" @click="saveRefresh(indexi)">
                                                    <i v-bind:class="refreshValue(modelvoorstel.werkelijkebelichting_n[indexi])"></i>
                                                </a>
                                            </td>
                                            <td v-if="voorstelbestaat">{{komma2(modelvoorstel.werkelijkebelichting_n[indexi].dliBelichting)}}</td>
                                            <template v-if="voorstelbestaat">
                                                <template v-for="(systeem, indexk) in modelvoorstel.werkelijkebelichting_n[indexi].systemen">
                                                    <td style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == (indexk + 1)) }">
                                                        {{systeem.belichtingsuren}}
                                                    </td>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar & voorstelbestaat">
                                            <td>
                                                <a href="javascript:void(0)" @click="klikt(indexi)">
                                                    <i v-bind:class="selectValue(werkelijk)"></i>
                                                </a>
                                            </td>
                                            <td style="text-align: center;" v-bind:class="genoegLicht(werkelijk.gewensteDli, modelvoorstel.werkelijkebelichting_n[indexi].totDlimetD - modelvoorstel.werkelijkebelichting_n[indexi].dliBelichting + dlitotaal[indexi])" >{{komma2(dlitotaal[indexi])}}</td>
                                            <template v-for="(perdag, indexj) in werkelijk.werkelijkperdag_n">
                                                <td style="text-align: center;" v-bind:class="{ rborder: (aantalsystemen == (indexj + 1)) }"><!-- {{perdag.tijd}} -->
                                                    <!-- zeker niet meer dan 50 schakelniveaus per afdeling -->
                                                    <input type="text" v-mask="'##:##'" autocomplete="off" @change="gewijzigd(indexi)" @keyup.delete="wis(perdag)" class="form-control unstyleduur" v-model="perdag.tijd" :id="'tijd' + ((indexi * 50) + indexj)" :name="'tijd' + ((indexi * 50) + indexj)" />
                                                    <!-- KOEN was v-model.lazy sneller maar v-mask is dan weg -->
                                                    <!-- <input required @keyup.delete="wis(perdag)" type="time" class="form-control unstyleduur" v-model="perdag.tijd" id="tijd" name="'tijd' + ((indexi * 50) + indexj)" /> -->
                                                </td>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar && urenbestaat">
                                            <td>{{komma2(modelklassiekeuren.klassiekebelichting_n[indexi].dliBelichting)}}</td>
                                            <template v-for="(klassiekperdag, indexk) in modelklassiekeuren.klassiekebelichting_n[indexi].klassiekperdag_n">
                                                <td style="text-align: center;">{{klassiekperdag.tijd}}</td>
                                            </template>
                                        </template>
                                        <template v-else><th></th></template>

                                    </tr>

                                    </tbody>
                                </table>
                            </div><!--/.col-->
                        </div><!--/.row-->

                        <!-- Energie -->
                        <div v-if="werkelijkbestaat && currentview == 'grafiek'" class="row animated fadeIn">
                            <div class="col-12">
                                <table class="table table-striped table-sm text-center table-fixed">
                                    <thead>
                                    <tr>
                                        <th class="rborder"></th>
                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" v-if="ideaalzichtbaar">Ideaal</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="toggleideaalzichtbaar()" title="toon/verberg">
                                                <i :class="[ideaalzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" v-if="voorstelzichtbaar">Voorstel</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="togglevoorstelzichtbaar()" title="toon/verberg">
                                                <i :class="[voorstelzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" v-if="werkelijkzichtbaar">Werkelijk</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="togglewerkelijkzichtbaar()" title="toon/verberg">
                                                <i :class="[werkelijkzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" v-if="urenzichtbaar">Klassiek</th>
                                        <th>
                                            <a href="javascript:void(0)" @click="toggleurenzichtbaar()" title="toon/verberg">
                                                <i :class="[urenzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                    </tr>
                                    <tr>
                                        <th class="rborder"></th>
                                        <template v-if="ideaalzichtbaar">
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen + 2)" class="rborder">Energie (kWh/m<sup>2</sup>)</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar">
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen + 2)" class="rborder">Energie (kWh/m<sup>2</sup>)</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <th style="text-align: center;">DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen + 2)" class="rborder">Energie (kWh/m<sup>2</sup>)</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar">
                                            <th style="text-align: center;">DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen + 2)">Energie (kWh/m<sup>2</sup>)</th>
                                        </template>
                                        <template v-else><th></th></template>
                                    </tr>
                                    <tr>
                                        <th class="rborder">Datum</th>
                                        <template v-if="ideaalzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                            <th>T</th>
                                            <th class="rborder">C</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                            <th>T</th>
                                            <th class="rborder">C</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                            <th>T</th>
                                            <th class="rborder">C</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                            <th>T</th>
                                            <th>C</th>
                                        </template>
                                        <template v-else><th></th></template>
                                    </tr>

                                    <!-- truukje om kolommen overeen te laten komen -->

                                    <tr style="visibility: collapse">
                                        <td class="rborder">22/02/2020</td>
                                        <template v-if="ideaalzichtbaar">
                                            <td>0.22</td>
                                            <template v-for="(systeem, indexk) in modellichtintegratie.klassiekebelichting_n[0].systemen">
                                                <td style="text-align: center;">0.23</td>
                                            </template>
                                            <td>{{komma2(energieideaaltotaal[model.werkelijkebelichting_n.length - 1])}}</td>
                                            <td class="rborder">{{komma2(energieideaalcumulatief[model.werkelijkebelichting_n.length - 1])}}</td>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar && voorstelbestaat">
                                            <td v-if="voorstelbestaat">0.24</td>
                                            <template v-if="voorstelbestaat">
                                                <template v-for="(systeem, indexk) in modelvoorstel.werkelijkebelichting_n[0].systemen">
                                                    <td style="text-align: center;">0.25</td>
                                                </template>
                                                <td>{{komma2(energievoorsteltotaal[model.werkelijkebelichting_n.length - 1])}}</td>
                                                <td class="rborder">{{komma2(energievoorstelcumulatief[model.werkelijkebelichting_n.length - 1])}}</td>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <td style="text-align: center;">0.26</td>
                                            <template v-for="(werkelijkperdag, indexk) in model.werkelijkebelichting_n[0].werkelijkperdag_n">
                                                <td style="text-align: center;">0.27</td>
                                            </template>
                                            <td>{{komma2(energiewerkelijktotaal[model.werkelijkebelichting_n.length - 1])}}</td>
                                            <td class="rborder">{{komma2(energiewerkelijkcumulatief[model.werkelijkebelichting_n.length - 1])}}</td>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar && urenbestaat">
                                            <td v-if="urenbestaat">0.28</td>
                                            <template v-if="urenbestaat">
                                                <template v-for="(klassiekperdag, indexk) in modelklassiekeuren.klassiekebelichting_n[0].klassiekperdag_n">
                                                    <td style="text-align: center;">0.29</td>
                                                </template>
                                                <td>{{komma2(energieklassiektotaal[model.werkelijkebelichting_n.length - 1])}}</td>
                                                <td>{{komma2(energieklassiekcumulatief[model.werkelijkebelichting_n.length - 1])}}</td>
                                            </template>
                                        </template>
                                        <template v-else><th></th></template>
                                    </tr>

                                    <!-- tot hier -->

                                    </thead>

                                    <tbody>

                                    <!-- truukje om kolommen overeen te laten komen -->

                                    <tr style="visibility: collapse">
                                        <th class="rborder"></th>
                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" v-if="ideaalzichtbaar">Ideaal</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="toggleideaalzichtbaar()" title="toon/verberg">
                                                <i :class="[ideaalzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" v-if="voorstelzichtbaar">Voorstel</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="togglevoorstelzichtbaar()" title="toon/verberg">
                                                <i :class="[voorstelzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" v-if="werkelijkzichtbaar">Werkelijk</th>
                                        <th class="rborder">
                                            <a href="javascript:void(0)" @click="togglewerkelijkzichtbaar()" title="toon/verberg">
                                                <i :class="[werkelijkzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" v-if="urenzichtbaar">Klassiek</th>
                                        <th>
                                            <a href="javascript:void(0)" @click="toggleurenzichtbaar()" title="toon/verberg">
                                                <i :class="[urenzichtbaar ? 'fa fa-outdent' : 'fa fa-indent']"></i>
                                            </a>
                                        </th>

                                    </tr>
                                    <tr style="visibility: collapse">
                                        <th class="rborder"></th>
                                        <template v-if="ideaalzichtbaar">
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen + 2)" class="rborder">Energie (kWh/m<sup>2</sup>)</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar">
                                            <th>DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen + 2)" class="rborder">Energie (kWh/m<sup>2</sup>)</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <th style="text-align: center;">DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen + 2)" class="rborder">Energie (kWh/m<sup>2</sup>)</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar">
                                            <th style="text-align: center;">DLI belichting</th>
                                            <th style="text-align: center;" :colspan="(aantalsystemen + 2)">Energie (kWh/m<sup>2</sup>)</th>
                                        </template>
                                        <template v-else><th></th></template>
                                    </tr>
                                    <tr style="visibility: collapse">
                                        <th class="rborder">Datum</th>
                                        <template v-if="ideaalzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                            <th>T</th>
                                            <th class="rborder">C</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                            <th>T</th>
                                            <th class="rborder">C</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                            <th>T</th>
                                            <th class="rborder">C</th>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar">
                                            <th>(mol/m<sup>2</sup>)</th>
                                            <template v-for="i in aantalsystemen">
                                                <th style="text-align: center;">{{i}}</th>
                                            </template>
                                            <th>T</th>
                                            <th>C</th>
                                        </template>
                                        <template v-else><th></th></template>
                                    </tr>

                                    <!-- tot hier -->

                                    <tr v-for="(werkelijk, indexi) in model.werkelijkebelichting_n">
                                        <td class="rborder">{{datumDDMMYYYY(werkelijk.datum)}}</td>
                                        <template v-if="ideaalzichtbaar">
                                            <td>{{komma2(modellichtintegratie.klassiekebelichting_n[indexi].dliBelichting)}}</td>
                                            <template v-for="(systeem, indexk) in modellichtintegratie.klassiekebelichting_n[indexi].systemen">
                                                <td style="text-align: center;">{{komma2(energieideaal[indexi].systeem[indexk].kwh)}}</td>
                                            </template>
                                            <td>{{komma2(energieideaaltotaal[indexi])}}</td>
                                            <td class="rborder">{{komma2(energieideaalcumulatief[indexi])}}</td>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="voorstelzichtbaar && voorstelbestaat">
                                            <td v-if="voorstelbestaat">{{komma2(modelvoorstel.werkelijkebelichting_n[indexi].dliBelichting)}}</td>
                                            <template v-if="voorstelbestaat">
                                                <template v-for="(systeem, indexk) in modelvoorstel.werkelijkebelichting_n[indexi].systemen">
                                                    <td style="text-align: center;">{{komma2(energievoorstel[indexi].systeem[indexk].kwh)}}</td>
                                                </template>
                                                <td>{{komma2(energievoorsteltotaal[indexi])}}</td>
                                                <td class="rborder">{{komma2(energievoorstelcumulatief[indexi])}}</td>
                                            </template>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="werkelijkzichtbaar">
                                            <td style="text-align: center;">{{komma2(dlitotaal[indexi])}}</td>
                                            <template v-for="(werkelijkperdag, indexk) in model.werkelijkebelichting_n[indexi].werkelijkperdag_n">
                                                <td style="text-align: center;">{{komma2(energiewerkelijk[indexi].werkelijkperdag[indexk].kwh)}}</td>
                                            </template>
                                            <td>{{komma2(energiewerkelijktotaal[indexi])}}</td>
                                            <td class="rborder">{{komma2(energiewerkelijkcumulatief[indexi])}}</td>
                                        </template>
                                        <template v-else><th class="rborder"></th></template>

                                        <template v-if="urenzichtbaar && urenbestaat">
                                            <td v-if="urenbestaat">{{komma2(modelklassiekeuren.klassiekebelichting_n[indexi].dliBelichting)}}</td>
                                            <template v-if="urenbestaat">
                                                <template v-for="(klassiekperdag, indexk) in modelklassiekeuren.klassiekebelichting_n[indexi].klassiekperdag_n">
                                                    <td style="text-align: center;">{{komma2(energieklassiek[indexi].klassiekperdag[indexk].kwh)}}</td>
                                                </template>
                                                <td>{{komma2(energieklassiektotaal[indexi])}}</td>
                                                <td>{{komma2(energieklassiekcumulatief[indexi])}}</td>
                                            </template>
                                        </template>
                                        <template v-else><th></th></template>
                                    </tr>

                                    </tbody>
                                </table><span style="float:right;width:40px;">&nbsp;</span>
                            </div><!--/.col-->
                        </div><!--/.row-->

                        <div v-show="werkelijkbestaat && currentview == 'grafiek'" class="row animated fadeIn">
                            <div class="col-12">
                                <h5 class="card-title mb-0">Cumulatief elektriciteitsverbruik</h5>
                                <br />
                                <div class="small text-muted">kWh/m<sup>2</sup></div>
                                <chart :chart-data="datacollection" class="chart-wrapper" style="height:400px;margin-top:10px;margin-bottom:40px;" height="400" :miny="miny" :maxy="maxy" :changeyaxis="changeyaxis"></chart>
                            </div>
                        </div>

                        <form @submit.prevent="saveItem">

                        <div slot="footer">
                            <b-button v-show="werkelijkbestaat" type="submit" variant="primary">
                                <span>Opslaan</span>
                            </b-button>
                            <b-button v-show="!werkelijkbestaat" type="button" @click="createschema" variant="primary">Formulier creëren</b-button>
                            <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                        </div>

                        </form>

                    </div>
                    <!-- einde urenbestaat -->

                    <div v-if="urenopgehaaldenbestaatniet" class="row">
                        <div class="col-12">
                            <p class="red">Er bestaat nog geen klassiek belichtingsschema voor deze teelt. Gelieve dit eerst te creëren.</p>
                            <br />
                            <b-button type="button" @click="back" variant="secondary">Terug</b-button>
                        </div>
                    </div>

                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import datefunctions from '../../helpers/datefunctions';
    import Chart from './ChartMixed';

    export default {
        name: 'Form',
        props: ['model', 'modellichtintegratie', 'invloedspercentages', 'modelvoorstel', 'modelklassiekeuren', 'isEditing'],
        data () {
            return {
                ideaalzichtbaar: true,
                voorstelzichtbaar: true,
                werkelijkzichtbaar: true,
                urenzichtbaar: true,
                firstrow: -1,
                currentview: 'data',
                datacollection: null,
                miny: 0,
                maxy: 25,
                changeyaxis: false, // telkens deze wijzigt, hertekent de grafiek zich
                begindatum: '',
                einddatum: '',
                disabled: {
                    to: new Date(),
                    from: new Date(),
                },
                bordercolors: ['rgba(255, 128, 0, 1)', 'rgba(0, 204, 204, 1)', 'rgba(255,20,147, 1)', 'rgba(255,221,50,1)', 'rgba(0, 0, 102,1)', 'rgba(193,46,12,1)', 'rgba(0,0,0,1)', 'rgba(50,205,50,1)', 'rgba(72,209,204,1)', 'rgba(139,0,139,1)'],
                fillcolors: ['rgba(255, 128, 0, 0.2)', 'rgba(0, 204, 204, 0.2)', 'rgba(255,20,147, 0.2)', 'rgba(255,221,50,0.2)', 'rgba(0, 0, 102,0.2)', 'rgba(193,46,12,0.2)', 'rgba(0,0,0,0.2)', 'rgba(50,205,50,0.2)', 'rgba(72,209,204,0.2)', 'rgba(139,0,139,0.2)'],
            };
        },
        methods: {
            toggleideaalzichtbaar () {
                this.ideaalzichtbaar = !this.ideaalzichtbaar;
            },
            togglevoorstelzichtbaar () {
                this.voorstelzichtbaar = !this.voorstelzichtbaar;
            },
            togglewerkelijkzichtbaar () {
                this.werkelijkzichtbaar = !this.werkelijkzichtbaar;
            },
            toggleurenzichtbaar () {
                this.urenzichtbaar = !this.urenzichtbaar;
            },
            changeView (view) {
                this.currentview = view;
                if (view === 'grafiek') {
                    if (this.begindatum === '') {
                        this.begindatum = new Date(this.model.werkelijkebelichting_n[0].datum);
                        this.einddatum = new Date(this.model.werkelijkebelichting_n[this.model.werkelijkebelichting_n.length - 1].datum);
                        this.disabled.to = this.begindatum;
                        this.disabled.from = this.einddatum;
                    }
                    this.fillGraphData();
                }
            },
            getMaxValueDatasets (datasets) {
                let maxwaarde = 0;
                datasets.forEach((dataset) => {
                    maxwaarde = Math.max(maxwaarde, Math.max(...dataset.data));
                });
                return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
            },
            fillGraphData () {
                this.datacollection = {
                    type: 'bar',
                    labels: this.getGraphLabels(),
                    datasets: this.getGraphBarsAndLines(),
                };
                this.miny = 0;
                this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
                this.changeyaxis = !this.changeyaxis;
            },
            getGraphLabels () {
                const labels = [];
                this.model.werkelijkebelichting_n.forEach((werkelijk) => {
                    if ((werkelijk.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (werkelijk.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        labels.push(this.datumDDMMYYYY(werkelijk.datum));
                    }
                });
                return labels;
            },
            getGraphBarsAndLines () {
                const datasets = [];
                this.getGraphIdeaal(datasets);
                this.getGraphVoorstel(datasets);
                this.getGraphWerkelijk(datasets);
                this.getGraphKlassiek(datasets);
                return datasets;
            },
            getGraphIdeaal (datasets) {
                const data = [];
                let indexi = 0;
                this.model.werkelijkebelichting_n.forEach((werkelijk) => {
                    if ((werkelijk.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (werkelijk.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.energieideaalcumulatief[indexi]));
                    }
                    indexi++;
                });
                const dataset = {
                    backgroundColor: 'rgba(0,204,0, 0)',
                    borderColor: 'rgba(0,204,0, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' Ideaal',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphVoorstel (datasets) {
                const data = [];
                let indexi = 0;
                this.model.werkelijkebelichting_n.forEach((werkelijk) => {
                    if ((werkelijk.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (werkelijk.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.energievoorstelcumulatief[indexi]));
                    }
                    indexi++;
                });
                const dataset = {
                    backgroundColor: 'rgba(0,153,153, 0)',
                    borderColor: 'rgba(0,153,153, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' Voorstel',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphWerkelijk (datasets) {
                const data = [];
                let indexi = 0;
                this.model.werkelijkebelichting_n.forEach((werkelijk) => {
                    if ((werkelijk.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (werkelijk.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.energiewerkelijkcumulatief[indexi]));
                    }
                    indexi++;
                });
                const dataset = {
                    backgroundColor: 'rgba(193,46,12, 0)',
                    borderColor: 'rgba(193,46,12, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' Werkelijk',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphKlassiek (datasets) {
                const data = [];
                let indexi = 0;
                this.modelklassiekeuren.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.energieklassiekcumulatief[indexi]));
                    }
                    indexi++;
                });
                const dataset = {
                    backgroundColor: 'rgba(139,0,139, 0)',
                    borderColor: 'rgba(0139,0,139, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' Klassiek',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            wis (perdag) {
                perdag.tijd = '';
            },
            klikt (index) {
                if (this.model.werkelijkebelichting_n[index].selected === 0) {
                    if (this.firstrow === -1) {
                        this.model.werkelijkebelichting_n[index].selected = 1;
                        this.firstrow = index;
                    } else if (this.firstrow < index) {
                        for (let i = this.firstrow + 1; i <= index; i += 1) {
                            for (let j = 0; j < this.model.werkelijkebelichting_n[this.firstrow].werkelijkperdag_n.length; j += 1) {
                                this.model.werkelijkebelichting_n[i].werkelijkperdag_n[j].tijd =
                                    this.model.werkelijkebelichting_n[this.firstrow].werkelijkperdag_n[j].tijd;
                                this.modelvoorstel.werkelijkebelichting_n[i].selected = 2;
                            }
                        }
                        this.model.werkelijkebelichting_n[this.firstrow].selected = 0;
                        this.firstrow = -1;
                    }
                } else {
                    this.model.werkelijkebelichting_n[index].selected = 0;
                    this.firstrow = -1;
                }
            },
            gewijzigd(index){
                this.modelvoorstel.werkelijkebelichting_n[index].selected = 2;
            },
            selectValue (werkelijk) {
                if (werkelijk.selected === 0) {
                    return 'fa fa-navicon';
                }
                if (werkelijk.selected === 1) {
                    return 'fa fa-sort-amount-asc';
                }
                return '';
            },
            refreshValue (voorstelwerkelijk) {
                if (voorstelwerkelijk.selected === 0) {
                    return 'fa fa-refresh licht';
                }
                if (voorstelwerkelijk.selected === 1) {
                    return 'fa fa-hourglass-half';
                }
                if (voorstelwerkelijk.selected === 2) {
                    return 'fa fa-refresh';
                }
                return '';
            },
            genoegLicht (nodig, hebje) {
                if (hebje >= nodig) {
                    return 'green';
                }
                if (hebje >= (nodig * 0.75)) {
                    return 'orange';
                }
                return 'red';
            },
            saveRefresh (indexi) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!this.isError) {
                            this.modelvoorstel.werkelijkebelichting_n[indexi].selected = 1;
                            this.$emit('save-refresh', this.model.id, this.model);
                        }
                    }
                });
            },
            createschema () {
                this.$emit('create-schema', this.model);
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!this.isError) {
                            this.$emit('save-item', this.model);
                        }
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
            datumDDMMYYYY (datum) {
                return datefunctions.datetoDDMMYYYY(datum);
            },
            timeHHMM (time) {
                return datefunctions.timetoHHMM(time);
            },
            berekenVermogen (schakelniveau, belichting) {
                /* eslint max-len: ["error", { "code": 300 }] */
                return (belichting.fotonflux * schakelniveau.percentage) / 100;
            },
            komma4 (waarde) {
                if (isNaN(waarde)) {
                    return '#.####';
                }
                return waarde.toFixed(4);
            },
            komma2 (waarde) {
                if (isNaN(waarde)) {
                    return '#.##';
                }
                return waarde.toFixed(2);
            },
            komma1 (waarde) {
                if (isNaN(waarde)) {
                    return '#.#';
                }
                return waarde.toFixed(1);
            },
            komma0 (waarde) {
                if (isNaN(waarde)) {
                    return '#';
                }
                return waarde.toFixed(0);
            },
        },
        computed: {
            werkelijkbestaat () {
                return (this.model.werkelijkebelichting_n.length !== 0);
            },
            voorstelbestaat () {
                return ((Object.keys(this.modelvoorstel).length !== 0) && (this.modelvoorstel.werkelijkebelichting_n.length !== 0));
            },
            urenbestaat () {
                return ((Object.keys(this.modelklassiekeuren).length !== 0) && (this.modelklassiekeuren.klassiekebelichting_n.length !== 0));
            },
            urenopgehaaldenbestaatniet () {
                return ((Object.keys(this.modelklassiekeuren).length !== 0) && (this.modelklassiekeuren.klassiekebelichting_n.length == 0));
            },
            aantalsystemen () {
                let aantal = 0;
                this.model.afdeling.belichting_n.forEach((belichting) => {
                    aantal += belichting.schakelniveau_n.length;
                });
                return aantal;
            },
            dlibelichting () {
                const resultaat = [];
                this.model.werkelijkebelichting_n.forEach((werkelijk) => {
                    const perdagarray = [];
                    werkelijk.werkelijkperdag_n.forEach((perdag, i) => {
                        perdagarray.push({ mol: ((datefunctions.getSeconden(perdag.tijd)
                            * this.installatie[i]) / 1000000) });
                    });
                    resultaat.push({ datum: werkelijk.datum, perdag: perdagarray });
                });
                return resultaat;
            },
            dlitotaal () {
                const resultaat = [];
                let i = 0;
                this.dlibelichting.forEach((dlibelichting) => {
                    let totaal = 0;
                    dlibelichting.perdag.forEach((perdag) => {
                        if (! isNaN(perdag.mol)) {
                            totaal += perdag.mol;
                        }
                    });
                    // totaal += parseFloat(this.model.werkelijkebelichting_n[i].dliZon); // de zon hier niet mee rekenen
                    resultaat.push(totaal);
                    i += 1;
                });
                return resultaat;
            },
            dlicumulatief () {
                const resultaat = [];
                let vorigtotaal = this.model.cumulatief;
                this.dlitotaal.forEach((dlitotaal) => {
                    resultaat.push(vorigtotaal + dlitotaal);
                    vorigtotaal += dlitotaal;
                });
                return resultaat;
            },
            // 4 keer hetzelfde (energie voor ideaal, werkelijk, voorstel en klassiek), is eigenlijk niet goed, maar ja
            energieideaal () {
                const resultaat = [];
                this.modellichtintegratie.klassiekebelichting_n.forEach((klassiekebelichting) => {
                    const systeemarray = [];
                    klassiekebelichting.systemen.forEach((systeem, i) => {
                        systeemarray.push({ kwh: (((datefunctions.getSeconden(systeem.belichtingsuren)
                            * this.installatie[i]) / systeem.efficientie) / 3600000)});
                    });
                    resultaat.push({ datum: klassiekebelichting.datum, systeem: systeemarray });
                });
                return resultaat;
            },
            energieideaaltotaal () {
                const resultaat = [];
                let i = 0;
                this.energieideaal.forEach((energieideaal) => {
                    let totaal = 0;
                    energieideaal.systeem.forEach((systeem) => {
                        if (! isNaN(systeem.kwh)) {
                            totaal += systeem.kwh;
                        }
                    });
                    resultaat.push(totaal);
                    i += 1;
                });
                return resultaat;
            },
            energieideaalcumulatief () {
                const resultaat = [];
                let vorigtotaal = 0;
                this.energieideaaltotaal.forEach((energieideaaltotaal) => {
                    resultaat.push(vorigtotaal + energieideaaltotaal);
                    vorigtotaal += energieideaaltotaal;
                });
                return resultaat;
            },
            energievoorstel () {
                const resultaat = [];
                this.modelvoorstel.werkelijkebelichting_n.forEach((werkelijkebelichting) => {
                    const systeemarray = [];
                    werkelijkebelichting.systemen.forEach((systeem, i) => {
                        systeemarray.push({ kwh: (((datefunctions.getSeconden(systeem.belichtingsuren)
                            * this.installatie[i]) / systeem.efficientie) / 3600000)});
                    });
                    resultaat.push({ datum: werkelijkebelichting.datum, systeem: systeemarray });
                });
                return resultaat;
            },
            energievoorsteltotaal () {
                const resultaat = [];
                let i = 0;
                this.energievoorstel.forEach((energievoorstel) => {
                    let totaal = 0;
                    energievoorstel.systeem.forEach((systeem) => {
                        if (! isNaN(systeem.kwh)) {
                            totaal += systeem.kwh;
                        }
                    });
                    resultaat.push(totaal);
                    i += 1;
                });
                return resultaat;
            },
            energievoorstelcumulatief () {
                const resultaat = [];
                let vorigtotaal = 0;
                this.energievoorsteltotaal.forEach((energievoorsteltotaal) => {
                    resultaat.push(vorigtotaal + energievoorsteltotaal);
                    vorigtotaal += energievoorsteltotaal;
                });
                return resultaat;
            },
            energiewerkelijk () {
                const resultaat = [];
                this.model.werkelijkebelichting_n.forEach((werkelijkebelichting) => {
                    const werkelijkperdagarray = [];
                    werkelijkebelichting.werkelijkperdag_n.forEach((werkelijkperdag, i) => {
                        werkelijkperdagarray.push({ kwh: (((datefunctions.getSeconden(werkelijkperdag.tijd)
                            * this.installatie[i]) / this.efficientie[i]) / 3600000)});
                    });
                    resultaat.push({ datum: werkelijkebelichting.datum, werkelijkperdag: werkelijkperdagarray });
                });
                return resultaat;
            },
            energiewerkelijktotaal () {
                const resultaat = [];
                let i = 0;
                this.energiewerkelijk.forEach((energiewerkelijk) => {
                    let totaal = 0;
                    energiewerkelijk.werkelijkperdag.forEach((werkelijkperdag) => {
                        if (! isNaN(werkelijkperdag.kwh)) {
                            totaal += werkelijkperdag.kwh;
                        }
                    });
                    resultaat.push(totaal);
                    i += 1;
                });
                return resultaat;
            },
            energiewerkelijkcumulatief () {
                const resultaat = [];
                let vorigtotaal = 0;
                this.energiewerkelijktotaal.forEach((energiewerkelijktotaal) => {
                    resultaat.push(vorigtotaal + energiewerkelijktotaal);
                    vorigtotaal += energiewerkelijktotaal;
                });
                return resultaat;
            },
            energieklassiek () {
                const resultaat = [];
                this.modelklassiekeuren.klassiekebelichting_n.forEach((klassiekebelichting) => {
                    const klassiekperdagarray = [];
                    klassiekebelichting.klassiekperdag_n.forEach((klassiekperdag, i) => {
                        klassiekperdagarray.push({ kwh: (((datefunctions.getSeconden(klassiekperdag.tijd)
                            * this.installatie[i]) / this.efficientie[i]) / 3600000)});
                    });
                    resultaat.push({ datum: klassiekebelichting.datum, klassiekperdag: klassiekperdagarray });
                });
                return resultaat;
            },
            energieklassiektotaal () {
                const resultaat = [];
                let i = 0;
                this.energieklassiek.forEach((energieklassiek) => {
                    let totaal = 0;
                    energieklassiek.klassiekperdag.forEach((klassiekperdag) => {
                        if (! isNaN(klassiekperdag.kwh)) {
                            totaal += klassiekperdag.kwh;
                        }
                    });
                    resultaat.push(totaal);
                    i += 1;
                });
                return resultaat;
            },
            energieklassiekcumulatief () {
                const resultaat = [];
                let vorigtotaal = 0;
                this.energieklassiektotaal.forEach((energieklassiektotaal) => {
                    resultaat.push(vorigtotaal + energieklassiektotaal);
                    vorigtotaal += energieklassiektotaal;
                });
                return resultaat;
            },
            installatie () {
                const resultaat = [];
                this.model.afdeling.belichting_n.forEach((belichting) => {
                    belichting.schakelniveau_n.forEach((schakelniveau) => {
                        resultaat.push(this.berekenVermogen(schakelniveau, belichting));
                    });
                });
                return resultaat;
            },
            efficientie () {
                const resultaat = [];
                this.model.afdeling.belichting_n.forEach((belichting) => {
                    belichting.schakelniveau_n.forEach((schakelniveau) => {
                        resultaat.push(belichting.efficientie);
                    });
                });
                return resultaat;
            },
        },
        components: {
            chart: Chart,
        },
    };
</script>

<style>

    table.scroll {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }

    .rborder
    {
        border-right: 1px solid #DDD;
    }

    .red {
        color: red;
    }
    .green {
        color: lawngreen;
    }
    .orange {
        color: orange;
    }
    .licht {
        color: #d4e1ee;
    }

    input, select {
        padding: .55em .5em;
        font-size: 100%;
        border: 1px solid #ccc;
        width: 100%
    }

    .unstyleduur {
        padding: 0.1em;
        width: 3em;
        text-align: center;
    }

    .centered {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .unstyleduur::-webkit-outer-spin-button, /* Removes arrows */
    .unstyleduur::-webkit-inner-spin-button, /* Removes arrows */
    .unstyleduur::-webkit-clear-button { /* Removes blue cross */
        -webkit-appearance: none;
        margin: 0;
    }
    /*.unstyleduur::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }*/

    .table-nonfluid {
        width: auto !important;
    }

    .table-fixed tbody {
        height: calc( 100vh - 240px );
        overflow-y: auto;
    }

    .table-fixed thead, .table-fixed tbody{
        display: block;
    }

</style>



// WEBPACK FOOTER //
// src/pages/licht/FormWerkelijk.vue